import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getNewsFormSingleNews = (state: IRootState) => state.newsForm.singleNews;
export const getNewsFormNewsId = (state: IRootState) => state.newsForm.newsId;
